var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-layout",
    {
      staticClass: "vs-button-toggle",
      attrs: {
        "no-gutter": "no-gutter",
        "auto-xs": "auto-xs",
        "grow-xs": "grow-xs"
      }
    },
    [
      _vm._l(_vm.options, function(option) {
        return [
          _vm.isObject(option)
            ? _c(
                "button",
                {
                  key: option.value,
                  staticClass: "vs-button-toggle__button",
                  class: {
                    "vs-button--disabled": option.value !== _vm.selectedOption,
                    "vs-button-toggle__button--disabled": _vm.processing
                  },
                  attrs: {
                    disabled:
                      option.value === _vm.selectedOption || _vm.processing
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("toggle", option.value)
                    }
                  }
                },
                [_vm._v(_vm._s(option.text))]
              )
            : _c(
                "button",
                {
                  key: option,
                  staticClass: "vs-button-toggle__button",
                  class: {
                    "vs-button--disabled": option !== _vm.selectedOption,
                    "vs-button-toggle__button--disabled": _vm.processing
                  },
                  attrs: {
                    disabled: option === _vm.selectedOption || _vm.processing
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("toggle", option)
                    }
                  }
                },
                [_vm._v(_vm._s(option))]
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }